import type { CtsUrlInterface } from '@/types/types';

export const carrierModule: CtsUrlInterface = {
  baseUrl: String(import.meta.env.VITE_CARRIER_URL),
};
